export { PartnersDisclaimer } from './PartnersDisclaimer';
